import React, { Component } from 'react';
import Page from '../pages/Page';
import DraftsContainer from '../containers/Drafts';
import { injectIntl } from 'react-intl';

class Drafts extends Component {
  getMetaData() {
    return {
      title: this.pageTitle(),
      meta: this.pageMeta(),
      link: this.pageLink()
    };
  }

  pageTitle = () => {
    return this.props.intl.formatMessage({id: 'drafts.pageTitle'});
  };

  pageMeta = () => {
    return [
      { name: 'description', content: this.props.intl.formatMessage({id: 'drafts.pageDescription'}) }
    ];
  };

  pageLink = () => {
    return [];
  };

  render() {
    return (
      <Page {...this.getMetaData()}>
        <DraftsContainer {...this.props} />
      </Page>
    );
  }
}

export default injectIntl(Drafts);



// WEBPACK FOOTER //
// app/pages/Drafts.jsx